export const initialScores = {
  acceleration: 0,
  focus: 0,
  handling: 0,
  cornering: 0,
  braking: 0,
  eco: 0,
  steadiness: 0,
  phone: 0,
  speed: 0,
  swerve: 0,
  total: 0,
};

export const tlStats = {
  acceleration: 0,
  alert: 0,
  cool: 0,
  cornering: 0,
  deceleration: 0,
  eco: 0,
  jerk: 0,
  phoneHandling: 0,
  speeding: 0,
  swerve: 0,
  total: 0,
};

export const initialImproved = [
  ["acceleration", 0],
  ["cornering", 0],
  ["braking", 0],
  ["steadiness", 0],
  ["phone", 0],
  ["speed", 0],
  ["swerve", 0],
];

export const indivStats = [
  "acceleration",
  "cornering",
  "braking",
  "steadiness",
  "phone",
  "speed",
  "swerve",
];

export const initFlippys = {
  avgEvents: 0,
  avgDriverScore: 0,
  totalTryps: 0,
  lwEvents: 0,
  lwDriverScore: 0,
};
